import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gmp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchDevices = (params = {}) => api.get("/devices", { params }).then((r) => r.data);
export const fetchDevice = (slug) => api.get(`/devices/${slug}`).then((r) => r.data);
export const fetchBrands = () => api.get("/devices/brands").then((r) => r.data);
export const fetchGuides = () => api.get("/guides").then((r) => r.data);
export const fetchGuide = (slug) => api.get(`/guides/${slug}`).then((r) => r.data);
export const triggerSync = () => api.post("/admin/sync/run").then((r) => r.data);
export const fetchSyncStatus = () => api.get("/admin/sync/status").then((r) => r.data);
